<!-- client-easy-app format
  <div class="row">
  <div class="text-right font-dark-green" [ngClass]="{'col-5':label, 'col-12':!label}" *ngIf="label">
    <span #elLabel *ngIf="!hideLabel" [ngClass]="{'label': fieldControl==='INPUT'}">{{label}}</span>
  </div>

  <div #elField class="no-padding" [ngClass]="{'col-7':label, 'col-12':!label}" *ngIf="!invalidRequiredInputList.length">
    <div class="row" style="margin:0px" *ngIf="isIconSeparated">
      <div class="col-11" *ngIf="fieldControl!=='INPUT'">
        <span *ngIf="!isEditState" >{{text}}</span>

        <! -- Inject custom content -- >
        <ng-content></ng-content>

        <input #elInput
          *ngIf="isEditState"
          class="mc-text-body field-input text-left"
          [(ngModel)]="editText"
          [formControl]="fmEditText"
          maxlength="10"
          [type]="type==='MSISDN'?'tel':'text'"
          mask= '0000000000'>
      </div>

      <div class="col-11" *ngIf="fieldControl==='INPUT'"> <! -- set to col-12 if need to expand for full row -- >

        <! -- Inject custom content -- >
        <ng-content></ng-content>

        <input #elInput
          class="mc-text-body field-input text-left"
          maxlength="10"
          value={{text}}
          disabled
          readonly />

        <span #elEyeImg *ngIf="canUnmask && (resFieldType === 1) && showEye"
          (click)="onClickEyeIcon()"
          class="eye-img"
          [ngClass]="{'eye-img--close': setMask}">
        </span>

      </div>

      <div class="col-1" *ngIf="fieldControl!=='INPUT'">
        <span #elEyeImg *ngIf="canUnmask && (resFieldType === 1) && showEye && (canEdit === 'no')"
          (click)="onClickEyeIcon()"
          class="eye-img"
          [ngClass]="{'eye-img--close': setMask}">
        </span>

        <span #elPenImg *ngIf="canEdit !== 'no' && canUnmask"
          (click)="onClickPenIcon(canEdit === 'yes')"
          class="pen-img float-right">
        </span>
      </div>
    </div>

    <! -- Fix icon to close to text field -- >
    <div class="row" style="margin:0px" *ngIf="!isIconSeparated">
      <div class="col">{{text}}
        <span #elEyeImg *ngIf="canUnmask && (resFieldType === 1) && showEye && (canEdit === 'no')"
        (click)="onClickEyeIcon()"
        class="eye-img"
        [ngClass]="{'eye-img--close': setMask}">
      </span>
      </div>
    </div>
    <! -----------------  ----------------- >

  </div>

  <div #elField  [ngClass]="{'col-7':label, 'col-12':!label}" *ngIf="invalidRequiredInputList.length">
    <span *ngFor="let required of invalidRequiredInputList">{{required}}</span>
  </div>
</div>

-->

<!-- lib - client-info -->
<div *ngIf="!isMultipleRef">
  <div [ngClass]="{ 'middle-container': fieldControl === 'INPUT', row: showAsRow }">
    <div class="small-3 large-3 columns text-right" [ngClass]="{ 'middle-item': fieldControl === 'INPUT' }"
      *ngIf="label && !hideLabel">
      <span #elLabel>{{ label }}</span>
    </div>

    <div #elField class="columns mask-text" [ngClass]="{
      'small-9': label,
      'small-12': !label,
      'mask-input': fieldControl === 'INPUT'
    }" *ngIf="!invalidRequiredInputList.length">
      <ng-container *ngIf="fieldControl !== 'INPUT'">
        <span (click)="onClickField($event)" *ngIf="!isEditState && !_underLine">{{ text }}</span>
        <span (click)="onClickField($event)" *ngIf="!isEditState && _underLine"><u>{{ text }}</u></span>
        <input #elInput *ngIf="isEditState" class="mc-text-body field-input text-left" [(ngModel)]="editText"
          [formControl]="fmEditText" type="text" />

        <span #elEyeImg *ngIf="canUnmask && resFieldType === 1 && showEye && canEdit === 'no'"
          (click)="onClickEyeIcon()" class="eye-img" [ngClass]="{ 'eye-img--close': setMask }">
        </span>

        <span #elPenImg *ngIf="canEdit !== 'no' && canUnmask" (click)="onClickPenIcon(canEdit === 'yes')"
          class="pen-img float-right">
        </span>
      </ng-container>

      <div class="mask-container" *ngIf="fieldControl === 'INPUT'"
        [ngStyle]="{ 'padding-left: 10px': insideMultiMask }">
        <input #elInput type="text" class="mc-input mask-input" [ngStyle]="{ 'width:100%': insideMultiMask }"
          value="{{ text }}" disabled readonly />
        <span #elEyeImg *ngIf="canUnmask && resFieldType === 1" class="eye-img-input"
          [ngClass]="{ 'eye-img-input--close': setMask }" (click)="onClickEyeIcon()"></span>
      </div>
    </div>

    <div #elField class="columns mask-text" [ngClass]="{ 'small-9': label, 'small-12': !label }"
      *ngIf="invalidRequiredInputList.length">
      <ul class="required-list" *ngIf="invalidRequiredInputList.length">
        <li *ngFor="let required of invalidRequiredInputList">{{ required }}</li>
      </ul>
    </div>
  </div>
</div>

<span *ngIf="isMultipleRef">
  <i class="bi bi-eye-fill" style="color: #74A822;"></i>
</span>